import React from "react";

export default function Wave({ color = "#3b82f6" }) {
  return (
    <div
      className="sine-wave"
      style={{
        // inject custom color (default blue)
        "--wave-color": color,
      }}
    ></div>
  );
}
